export const getDateFormat = date => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ]
  const rawDate = new Date(date)
  const day = rawDate.getDate()
  const monthIndex = rawDate.getMonth()
  const monthName = monthNames[monthIndex]
  const year = rawDate.getFullYear()

  return `${day} ${monthName} ${year}`
}
